import { Dimension } from 'features/charts-v2/types'

/**
 * Dimension value sent to the backend for breakdowns.
 * Most are Dimension enum; 'country' is a virtual dimension the backend expands to COALESCE(POST_COUNTRY, SOURCE_COUNTRY).
 */
export type IssueBreakdownDimension = Dimension | 'country'

/**
 * Subset of breakdowns relevant for issue analysis.
 * Standard: Brand, Product, Source, Promotional, Country, Dataset.
 */
export const ISSUE_BREAKDOWN_OPTIONS = {
  BRAND: {
    id: 'brand' as const,
    label: 'Brand',
    dimension: Dimension.PRODUCT_BRAND as IssueBreakdownDimension,
  },
  PRODUCT: {
    id: 'product' as const,
    label: 'Product',
    dimension: Dimension.PRODUCT_HIERARCHY as IssueBreakdownDimension,
  },
  SOURCE: {
    id: 'source' as const,
    label: 'Source',
    dimension: Dimension.SOURCE_NAME as IssueBreakdownDimension,
  },
  PROMOTIONAL: {
    id: 'promotional' as const,
    label: 'Promotional',
    dimension: Dimension.POST_PROMOTION as IssueBreakdownDimension,
  },
  COUNTRY: {
    id: 'country' as const,
    label: 'Country',
    dimension: 'country' as IssueBreakdownDimension,
  },
  DATASET: {
    id: 'dataset' as const,
    label: 'Dataset',
    dimension: Dimension.SOURCE_PROJECT_ID as IssueBreakdownDimension,
  },
} as const

export type IssueBreakdownOption = keyof typeof ISSUE_BREAKDOWN_OPTIONS

/** Value for the breakdown Select: standard option key or custom:model:field */
export type IssueBreakdownSelectionValue = IssueBreakdownOption | string

/**
 * Helper to get dimension string from breakdown option.
 * Returns the backend dimension value (e.g., "product_brand", "source_name", "country").
 */
export function getDimensionFromOption(option: IssueBreakdownOption): string {
  return String(ISSUE_BREAKDOWN_OPTIONS[option].dimension)
}

/**
 * Helper to get the display label for a breakdown option.
 */
export function getBreakdownLabel(option: IssueBreakdownOption): string {
  return ISSUE_BREAKDOWN_OPTIONS[option].label
}
